import script from "./HeaderAuth.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderAuth.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderAuth.vue?vue&type=style&index=0&id=768e4231&lang=scss&scoped=true"

import exportComponent from "/mnt/c/Users/mssuzuki/work/fidev/nicotto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-768e4231"]])

export default __exports__